import React, { useState } from "react";

import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { Eye, EyeOff, Loader2 } from "lucide-react";

const PasswordSelectForm = (props) => {
  const { user, handleConfirmationSubmit, formSubmitting } = props;
  const [password, setPassword] = useState("");
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [passwordConfirmationVisible, setPasswordConfirmationVisible] =
    useState(false);

  const validationSchema = Yup.object().shape({
    password: Yup.string()
      .min(8, "La contraseña debe tener al menos 8 caracteres")
      .required("Ingresa una contraseña"),
    password_confirmation: Yup.string()
      .oneOf([Yup.ref("password"), null], "Las contraseñas no coinciden")
      .required("Confirma tu contraseña"),
  });

  return (
    <div>
      <h2 className="font-bold text-white text-3xl md:text-3xl leading-6">
        Un último paso, elige una contraseña
      </h2>
      <p className="text-gray-500 text-md mt-2">
        Elige la contraseña que usarás para ingresar al sitio cada vez que lo
        necesites
      </p>
      <Formik
        initialValues={{
          password: user.password,
          password_confirmation: user.password,
        }}
        validationSchema={validationSchema}
        validateOnMount
        onSubmit={(values) => {
          if (values.password == values.password_confirmation) {
            handleConfirmationSubmit(values);
          }
        }}
      >
        {({ errors, touched, isValid }) => (
          <Form className="space-y-6 mt-4 pb-6">
            <div>
              <div className="relative">
                <div>
                  <Field
                    name="password"
                    type={passwordVisible ? "text" : "password"}
                    placeholder="Contraseña"
                    className={`appearance-none block w-full bg-gray-900 text-gray-400 px-3 py-2 border-2 border-gray-800 rounded-md placeholder-gray-700 focus:outline-none focus:shadow-outline-blue focus:border-gray-600 transition duration-150 ease-in-out sm:text-sm sm:leading-5 ${
                      touched.password && errors.password
                        ? "border-red-400 focus:border-red-400 placeholder-red-400"
                        : ""
                    }`}
                  />
                  {touched.password && errors.password && (
                    <span className="text-xs text-red-400 mt-1">
                      {errors.password}
                    </span>
                  )}
                </div>
                <div
                  className="w-6 h-6 absolute"
                  onClick={() => {
                    setPasswordVisible(!passwordVisible);
                  }}
                  style={{ right: 10, top: 10 }}
                >
                  {passwordVisible ? (
                    <EyeOff className="absolute w-4 h-4 text-gray-600 cursor-pointer" />
                  ) : (
                    <Eye className="absolute w-4 h-4 text-gray-600 cursor-pointer" />
                  )}
                </div>
              </div>
            </div>
            <div className="relative">
              <div>
                <Field
                  name="password_confirmation"
                  type={passwordConfirmationVisible ? "text" : "password"}
                  placeholder="Confirma tu contraseña"
                  className={`appearance-none block w-full bg-gray-900 text-gray-400 px-3 py-2 border-2 border-gray-800 rounded-md placeholder-gray-700 focus:outline-none focus:shadow-outline-blue focus:border-gray-600 transition duration-150 ease-in-out sm:text-sm sm:leading-5 ${
                    touched.password_confirmation &&
                    errors.password_confirmation
                      ? "border-red-400 focus:border-red-400 placeholder-red-400"
                      : ""
                  }`}
                />
                {touched.password_confirmation &&
                  errors.password_confirmation && (
                    <span className="text-xs text-red-400 mt-1">
                      {errors.password_confirmation}
                    </span>
                  )}
              </div>
              <div
                className="w-6 h-6 absolute"
                onClick={() => {
                  setPasswordConfirmationVisible(!passwordConfirmationVisible);
                }}
                style={{ right: 10, top: 10 }}
              >
                {passwordConfirmationVisible ? (
                  <EyeOff className="absolute w-4 h-4 text-gray-600 cursor-pointer" />
                ) : (
                  <Eye className="absolute w-4 h-4 text-gray-600 cursor-pointer" />
                )}
              </div>
            </div>

            <span className="block w-full rounded-md shadow-sm">
              <button
                type="submit"
                disabled={!isValid}
                className="w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-primary-500  hover:opacity-75 focus:outline-none focus:border-gray-900 disabled:opacity-50 focus:shadow-outline-indigo active:bg-gray-800 transition duration-150 ease-in-out"
              >
                {formSubmitting ? (
                  <div>
                    Enviando información{" "}
                    <Loader2 className="inline-block w-4 h-4 ml-1 animate-spin" />
                  </div>
                ) : (
                  <span>Unirme a la Open Week</span>
                )}
              </button>
            </span>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default PasswordSelectForm;
